import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';

// Componente Lote con lógica para colores y Tooltip de MUI
const Lote = ({ lote, currencySymbol,  onSeleccionarLote }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Define el manejador de clics basado en el estado del lote
  const onClickHandler = lote.ContratoActivo !== 1 && lote.ReservaActiva !== 1 ? () => onSeleccionarLote(lote) : undefined;

  const getLoteStyles = () => {
    let styles = {
      cursor: onClickHandler ? 'pointer' : 'default', // Cambia el cursor si hay un manejador de clics
      borderRadius: '5px',
      fontSize: '0.8em',
      fontFamily: 'Rubik, sans-serif',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.50)',
      color: 'white !important',
      width: '40px', // Asegura que todos los botones tengan el mismo ancho mínimo
      height: '50px', // Asegura que todos los botones tengan la misma altura
      display: 'flex', // Habilita la posibilidad de alinear el contenido del botón
      alignItems: 'center', // Centra el contenido del botón verticalmente
      justifyContent: 'center', // Centra el contenido del botón horizontalmente
      '&:hover': {},
    };
  
    if (lote.ContratoActivo === 1) {
      styles.backgroundColor = 'grey';
    } else if (lote.ReservaActiva === 1) {
      styles.backgroundColor = isHovered ? 'lightgreen' : 'orange';
      // Define el estilo :hover solo para los lotes con reserva activa
      styles['&:hover'].backgroundImage = 'radial-gradient(circle, #666666, orange)';
    } else {
      styles.backgroundColor = isHovered ? 'lightgreen' : 'green';
      styles['&:hover'].backgroundImage = 'radial-gradient(circle, lightgreen, green)';
    }
  
    return styles;
  };

  const loteStyles = getLoteStyles();

  //const tooltipText = `${lote.Lote} ${lote.ContratoActivo === 1 ? 'VENDIDO' : lote.ReservaActiva === 1 ? 'RESERVADO' : ''} - Precio: $${lote.Precio}, Superficie: ${lote.Superficie}m²`;
  const tooltipText = lote.ContratoActivo === 1
  ? `${lote.Lote} - VENDIDO`
  : lote.ReservaActiva === 1
  ? `${lote.Lote} - RESERVADO hasta el ${lote.FechaVencimiento} - ${currencySymbol} ${parseFloat(lote.Precio).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  : `${lote.Lote} - ${currencySymbol} ${parseFloat(lote.Precio).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}, Superficie: ${lote.Superficie}m²`;


  return (
    <Tooltip title={tooltipText} TransitionComponent={Fade}
    TransitionProps={{ timeout: 600 }} arrow>
      <Button
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClickHandler}
        sx={loteStyles}
      >
        {lote.Lote} {lote.Pago} 
      </Button>
    </Tooltip>
  );
};

export default Lote;
